<template lang="pug">
  .box
    .blockOne
      .oneHeader
        h3 产品概述
        .blue
      .oneBody
        .pBox
          p 速云食堂基于政府机关、企事业单位食堂管理模式，多端互通，创新打造的食堂订餐及就餐模式，包括在线自主充值、点餐、线下扫码取餐等，满足内部食堂多样化餐饮模式的需求，同时系统具备强大的后台管理功能，不仅包含用户管理、点餐数量限制、菜谱管理、订单统计等，为食堂管理者提供食堂优化运营的数据支撑，提升就餐者就餐体验和食堂服务水平。
        img(src="../../assets/images/canteen/c1.jpg" alt="")
    .blockTwo
      .twoHeader
        h3 客户痛点
        .blue
      .twoBody
        img(src="../../assets/images/canteen/c2.jpg" alt="")
        .pBox
          p 1、就餐时间集中，就餐效率较低：职工用餐时间集中，人流量大，食堂排队拥堵，用餐体验差。
          p 2、食堂运营成本高：食堂剩餐率较高，由于无法预估就餐人数，导致食堂备餐时浪费的现象比较严重。
          p 3、财务统计工作量大、繁琐：由于食堂财务在核算的时候涉及到多个类别，工作量大，极易造成数据准确性有偏差、数据留存性低的问题。
          p 4、管理模式粗放：缺乏统一管控，导致整体经营成本高。
    .blockOne
      .oneHeader
        h3 产品功能
        .blue
      .oneBody
        .one
          h3 1. 在线点餐
          img(src="../../assets/images/canteen/c3.jpg" alt="")
          .ps
            p 工作台各食堂预制菜品列表图文展示，在可线自主选择菜品，支持自定义设定单次点餐数量。
            p 灵活的在线订餐方式：可自定义提前订餐天数，如提前一天、两天、三天等，节假日不受限制。
        .two
          h3 2. 快捷下单 在线支付
          .ps
            p 用餐订单列表支持二次确认，智能核算的用餐消费金额。
            p 订单状态实时更新：订餐成功自动推送就餐者及食堂管理人员知晓，实现精准备餐。
            p 自主查询，方便实用：食堂管理人员可在线查看当天或者明天订餐情况，精准备餐，避免遗漏。
          img(src="../../assets/images/canteen/c4.jpg" alt="")
        .three
          h3 3. 菜品排行榜
          img(src="../../assets/images/canteen/c5.jpg" alt="")
          p 基于对用户点餐次数及用户评价等数据分析，智能推出好评菜品排行榜，前三名菜品突出显示，引导就餐者消费，激励各个食堂推陈出新，大幅度提高就餐者对饮食服务的满意度让更多人回归食堂。
        .one
          h3(style="text-align:right;") 4. 订单列表
          img(src="../../assets/images/canteen/c6.jpg" alt="")
          .ps
            p 用餐订单列表展示。
            p 规定时间内可取消订餐：就餐者在订餐结束前，可取消预约的用餐订单。
            p 订单状态突出显示（已下单/取消订单），并以不同颜色加以标识区分，一目了然。
            p 可在线查阅订单明细。
        .three
          h3 5. 在线充值 智能统计
          img(src="../../assets/images/canteen/c7.jpg" alt="")
          p(style="text-align:left;padding:10px 0 0;") 在线充值、消费记录直观展现：就餐者自主线上多渠道预充值，订餐智能核算扣费，订餐记录详情展现。
          p(style="text-align:left;padding:10px 0 0;") 智能统计：以日、月、年为单位智能统计消费金额，可视化展现，便于就餐者及时掌握个人消费情况，合理规划。
        .two
          h3 6. 线下取餐
          .ps(style="width: 30%;margin:100px 0 0 100px;")
            p 订单信息即时推送食堂管理人员知晓，加强了员工和内部食堂之间的互动。
            p 支持用餐者线下扫码取餐，有效避免了排队点餐、取餐的拥堵。
            p 提高就餐效率及食堂服务水平。
          img(src="../../assets/images/canteen/c8.jpg" alt="" style="width: 30%;margin-right:100px;")
    .blockTwo(style="background-color: #f2f2f2;margin-bottom:0;")
      .twoHeader
        h3 产品价值
        .blue
      .twoBody(style="height:300px;")
        img.img(src="../../assets/images/canteen/c9.png" alt="")
        p.up 轻松全面了解就餐数据，省时省力，高效率，实现食堂管理精细化。
        p.left 智能管理后台台账，节约组织管理成本，加快组织内部食堂信息化脚步，提升组织对外形象。
        p.bottom 有效提升食堂售卖效率，降本增效，实现精准备餐，智能经营报表，分析透彻。
        p.right 增加与食堂的有效沟通，点餐、就餐方便快捷，提高就餐体验。
    .blockOne
      .oneHeader
        h3(style="padding-top:30px;") 硬件信息
        .blue
      .oneBody
        ul(style="margin-left:30px;")
          li
            .yuan
              img(src="../../assets/images/canteen/c10.png" alt="")
            .oneBox
              h3 魔点G2
              p 活体识别，安全保障；
              p 99.99%精准识别度，比肩金融级人脸支付。
          li
            .yuan
              img(src="../../assets/images/canteen/c11.png" alt="")
            .oneBox
              h3 魔点D2
              p 混合光谱技术，抵御照片/视频的攻击；
              p 离线支持10000张人脸底库；
              p 99.99%精准识别度，比肩金融级人脸支付。
              p 根据企业要求可自定义语音包，满足企业个性化需求。
          li
            .yuan
              img(src="../../assets/images/canteen/c13.png" alt="")
            .oneBox
              h3 扫码机
              p 快速扫码，缩短排队时长；
              p 支付收款自带提示音，再忙不怕漏单；
              p 即插即用，性能稳定。
        .line
        ul(style="float:right;margin-right:30px;")
          li
            .yuan
              img(src="../../assets/images/canteen/c12.png" alt="")
            .oneBox
              h3 魔点D3
              p 一米内精准拾音，听懂你的每个瞬间；
              p 首创三摄，采用混合光谱技术，可抵御照片视频攻击，搭载HDR宽动态摄像头，复杂光下也可清晰识别；
              p 内置嵌入式神经网络处理器，采用深度靴子算法，性能卓越。
          li
            .yuan
              img(src="../../assets/images/canteen/c14.png" alt="")
            .oneBox
              h3 小票机
              p 支持各种平台，多种收银/打印软件；
              p 真人语音版播报：开机提醒、缺纸提醒、连接成功提醒；
              p 刀口锋利，撕纸整齐，提高效率。
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.commit('changeNavOther', 2)
  }
}
</script>

<style lang="less" scoped>
  .blockOne{
    width: 70%;
    margin: 0 auto 68px;
    .oneHeader{
      font-size: 20px;
      padding-bottom: 30px;
      h3{
        font-weight: 400;
      }
      .blue{
        float: left;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .oneBody{
      text-align: justify;
      overflow: hidden;
      .pBox{
        float: left;
        width: 35%;
        padding: 20px;
        line-height: 26px;
        border: 1px solid #409fee;
        border-radius: 10px;
        text-indent: 2em;
        margin-top: 40px;
      }
      img{
        float: right;
        width: 60%;
        margin-top: 10px;
      }
      .one,.two{
        overflow: hidden;
        h3{
          font-weight: 400;
          margin: 10px 0;
        }
        img{
          float: left;
          width: 50%;
        }
        .ps{
          float: right;
          width: 35%;
          padding: 20px;
          border-radius: 10px;
          background-color: #f0f0f0;
          line-height: 26px;
          text-indent: 2em;
          margin: 76px 30px 0 0;
          box-shadow: -2px 2px 10px rgba(0, 0, 0, .3);
        }
      }
      .two{
        h3{
          text-align: right;
        }
        img{
          float: right;
        }
        .ps{
          float: left;
          box-shadow: 2px 2px 10px rgba(0, 0, 0, .3);
          margin-top: 88px;
        }
      }
      .three{
        h3{
          font-weight: 400;
          margin: 10px 0;
        }
        img{
          display: block;
          float: none;
          width: 80%;
          margin: auto;
        }
        p{
          width: 80%;
          margin: 0 auto;
          padding: 20px;
          text-align: center;
          line-height: 26px;
        }
      }
    }
    ul{
      width: 40%;
      float: left;
      li{
        overflow: hidden;
        // height: 102px;
        margin-bottom: 10px;
        .yuan{
          width: 80px;
          height: 100px;
          line-height: 60px;
          float: left;
          margin-top: 5px;
          img{
            width: 100%;
          }
        }
        .oneBox{
          float: left;
          width: 76%;
          margin-left: 10px;
          h3{
            margin-bottom: 5px;
          }
          p{
            font-size: 14px;
            line-height: 24px;
          }
        }
      }
    }
    .line{
      float: left;
      width: 1px;
      height: 438px;
      background-color: #ccc;
      margin-left: 58px;
    }
  }
  .blockTwo{
    padding: 0 15% 20px;
    background-color: #f9f9f9;
    margin-bottom: 20px;
    .twoHeader{
      font-size: 20px;
      padding: 30px 0;
      h3{
        font-weight: 400;
        text-align: right;
      }
      .blue{
        float: right;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .twoBody{
      overflow: hidden;
      position: relative;
      img{
        float: left;
        width: 35%;
        height: 300px;
      }
      .pBox{
        float: right;
        width: 50%;
        background-image: url(../../assets/images/platform/bc1.jpg);
        background-size: cover;
        padding: 80px 66px 20px;
        text-align: justify;
        line-height: 26px;
      }
      .img{
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 50%;
      }
      .up,.left,.bottom,.right{
        position: absolute;
        width: 25%;
        text-indent: 2em;
      }
      .up{
        top: 45px;
        left: 0px;
      }
      .left{
        top: 26px;
        right: 0px;
      }
      .bottom{
        bottom: 32px;
        left: 0px;
      }
      .right{
        bottom: 33px;
        right: 0px;
      }
    }
  }
</style>
